// extracted by mini-css-extract-plugin
export default {"personalInformationMobile":"PersonalInformationMobile_personalInformationMobile__YmKCe","editButton":"PersonalInformationMobile_editButton__RW4O4"};